import { render } from "./PlaylistCarousel.vue?vue&type=template&id=33257a3c"
import script from "./PlaylistCarousel.vue?vue&type=script&lang=js"
export * from "./PlaylistCarousel.vue?vue&type=script&lang=js"

import "./PlaylistCarousel.vue?vue&type=style&index=0&id=33257a3c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__